var map = {
	"./10-gm-achieved.png": 456,
	"./10-gm-achieved.svg": 155,
	"./10-gm-achieved_old.svg": 417,
	"./10-gm-unachieved.jpg": 621,
	"./10-gm-unachieved.png": 154,
	"./10-gm-unachieved_old.svg": 418,
	"./10000-gift-voucher.svg": 250,
	"./10gm-gold-coin.svg": 251,
	"./10k-Gift-Voucher.svg": 419,
	"./10k-achieved.svg": 159,
	"./10k-unachieved.svg": 158,
	"./10l-act.svg": 130,
	"./10l-inact.svg": 212,
	"./1l-act.svg": 216,
	"./1l-inact.svg": 210,
	"./1st.svg": 205,
	"./25l-act.svg": 218,
	"./25l-inact.svg": 213,
	"./2nd.svg": 206,
	"./3000-gift-voucher.svg": 252,
	"./3k-achieved.svg": 161,
	"./3k-unachieved.svg": 160,
	"./3l-act.svg": 217,
	"./3l-inact.svg": 211,
	"./3rd.svg": 207,
	"./404.png": 318,
	"./5-gm-achieved.svg": 157,
	"./5-gm-achieved_old.svg": 420,
	"./5-gm-unachieved.svg": 156,
	"./5-gm-unachieved_old.svg": 421,
	"./502.png": 319,
	"./5gm-gold-coin.svg": 253,
	"./5l-act.svg": 422,
	"./5l-inact.svg": 423,
	"./Arrow Back2x.png": 457,
	"./Astra/Blue.gif": 409,
	"./Astra/Brown.gif": 410,
	"./Astra/Green.gif": 411,
	"./Astra/Retailer/R0.png": 133,
	"./Astra/Retailer/R10.png": 220,
	"./Astra/Retailer/R100.gif": 344,
	"./Astra/Retailer/R100.png": 221,
	"./Astra/Retailer/R20.png": 222,
	"./Astra/Retailer/R30.png": 223,
	"./Astra/Retailer/R40.png": 224,
	"./Astra/Retailer/R50.png": 225,
	"./Astra/Retailer/R60.png": 226,
	"./Astra/Retailer/R70.png": 227,
	"./Astra/Retailer/R80.png": 228,
	"./Astra/Retailer/R90.png": 229,
	"./Astra/Sale/S0.png": 132,
	"./Astra/Sale/S10.png": 230,
	"./Astra/Sale/S100.gif": 345,
	"./Astra/Sale/S100.png": 231,
	"./Astra/Sale/S100_1.gif": 346,
	"./Astra/Sale/S20.png": 232,
	"./Astra/Sale/S30.png": 233,
	"./Astra/Sale/S40.png": 234,
	"./Astra/Sale/S50.png": 235,
	"./Astra/Sale/S60.png": 236,
	"./Astra/Sale/S70.png": 237,
	"./Astra/Sale/S80.png": 238,
	"./Astra/Sale/S90.png": 239,
	"./Astra/Service/SE0.png": 134,
	"./Astra/Service/SE10.png": 240,
	"./Astra/Service/SE100.gif": 347,
	"./Astra/Service/SE100.png": 241,
	"./Astra/Service/SE20.png": 242,
	"./Astra/Service/SE30.png": 243,
	"./Astra/Service/SE40.png": 244,
	"./Astra/Service/SE50.png": 245,
	"./Astra/Service/SE60.png": 246,
	"./Astra/Service/SE70.png": 247,
	"./Astra/Service/SE80.png": 248,
	"./Astra/Service/SE90.png": 249,
	"./Astra/a.png": 348,
	"./Astra/blueline.png": 349,
	"./Astra/brownline.png": 350,
	"./Astra/greenline.png": 351,
	"./BKB-Elements/1st-final.gif": 622,
	"./BKB-Elements/Asta Hole.png": 458,
	"./BKB-Elements/Astra bg.png": 459,
	"./BKB-Elements/Bg img 2.png": 460,
	"./BKB-Elements/Congratulations text.svg": 424,
	"./BKB-Elements/Final milestone.png": 461,
	"./BKB-Elements/FullStone.png": 219,
	"./BKB-Elements/Group 12090.png": 462,
	"./BKB-Elements/Group_12090@2x.svg": 425,
	"./BKB-Elements/Individual rank card.svg": 426,
	"./BKB-Elements/Milestone 10L.svg": 101,
	"./BKB-Elements/Milestone 1L.svg": 85,
	"./BKB-Elements/Milestone 25L.svg": 87,
	"./BKB-Elements/Milestone 5L.svg": 86,
	"./BKB-Elements/Rank table card.svg": 427,
	"./BKB-Elements/Rank.png": 209,
	"./BKB-Elements/Rank_top_nav_bar_bg1.svg": 428,
	"./BKB-Elements/Rank_top_nav_bar_bg2.png": 463,
	"./BKB-Elements/Rank_top_nav_bar_button.png": 169,
	"./BKB-Elements/Stone-1.gif": 406,
	"./BKB-Elements/Stone-2.gif": 407,
	"./BKB-Elements/Stone-3.gif": 408,
	"./BKB-Elements/Target Bar.svg": 429,
	"./BKB-Elements/Total poitns card.svg": 430,
	"./BKB-Elements/You have earned 100% bonus point (final popup).svg": 431,
	"./BKB-Elements/bg.gif": 382,
	"./BKB-Elements/bg.png": 464,
	"./BKB-Elements/bg_astra.png": 465,
	"./BKB-Elements/bg_gif.gif": 623,
	"./BKB-Elements/bg_new.png": 168,
	"./BKB-Elements/bonus icon.svg": 432,
	"./BKB-Elements/full_stone.png": 368,
	"./BKB-Elements/milestone-progress-bar.svg": 433,
	"./BKB-Elements/ok_button.png": 369,
	"./BKB-Elements/p1.svg": 59,
	"./BKB-Elements/points-bar.png": 466,
	"./BKB-Elements/points_bar.png": 467,
	"./BKB-Elements/profile-bg.svg": 434,
	"./BKB-Elements/retailer_bg.gif": 403,
	"./BKB-Elements/sale_bg.gif": 404,
	"./BKB-Elements/service_bg.gif": 405,
	"./Calendar-icon.png": 188,
	"./CanonBig.gif": 272,
	"./Cash_Collection.png": 327,
	"./Daily_invest.png": 329,
	"./Ended.svg": 150,
	"./Impact_player_screen/CompletedAstra/blank.png": 370,
	"./Impact_player_screen/CompletedAstra/unnamed.png": 468,
	"./Impact_player_screen/CompletedAstra/with_text.png": 254,
	"./Impact_player_screen/CompletedAstra/with_text_old.png": 469,
	"./Impact_player_screen/Onboarding_screen/Frame 11778.gif": 624,
	"./Impact_player_screen/Onboarding_screen/Screen1.gif": 537,
	"./Impact_player_screen/Onboarding_screen/Screen2.png": 371,
	"./Impact_player_screen/Onboarding_screen/Screen3.gif": 538,
	"./Impact_player_screen/Onboarding_screen/live_war.gif": 341,
	"./Impact_player_screen/Onboarding_screen/normal_day.png": 215,
	"./Impact_player_screen/Onboarding_screen/two_days_back.png": 255,
	"./Impact_player_screen/home_screen/ArrowBack.png": 372,
	"./Impact_player_screen/home_screen/Back_to_Home.png": 373,
	"./Impact_player_screen/home_screen/Border_daily_points.png": 170,
	"./Impact_player_screen/home_screen/Daily_total_points_bg.png": 470,
	"./Impact_player_screen/home_screen/EnterBKB.png": 374,
	"./Impact_player_screen/home_screen/Group 12457.png": 471,
	"./Impact_player_screen/home_screen/Group 12462.png": 472,
	"./Impact_player_screen/home_screen/Group_12509.png": 340,
	"./Impact_player_screen/home_screen/Impact ranking.png": 473,
	"./Impact_player_screen/home_screen/Points_being_collected.gif": 377,
	"./Impact_player_screen/home_screen/Points_being_collected_pld.gif": 534,
	"./Impact_player_screen/home_screen/Timer.png": 474,
	"./Impact_player_screen/home_screen/background.gif": 167,
	"./Impact_player_screen/home_screen/bg_daily_points.png": 475,
	"./Impact_player_screen/home_screen/claim_2x.png": 375,
	"./Impact_player_screen/home_screen/impact_player.png": 476,
	"./Impact_player_screen/home_screen/impact_player_bonus.png": 477,
	"./Impact_player_screen/home_screen/misile.gif": 535,
	"./Impact_player_screen/home_screen/movingFullStone.gif": 378,
	"./Impact_player_screen/home_screen/mumbai.png": 162,
	"./Impact_player_screen/home_screen/next_icon.png": 256,
	"./Impact_player_screen/home_screen/points_bg.png": 478,
	"./Impact_player_screen/home_screen/ranking_bg.png": 258,
	"./Impact_player_screen/home_screen/score card.svg": 435,
	"./Impact_player_screen/home_screen/stamp_2x.gif": 379,
	"./Impact_player_screen/home_screen/stamp_5x.gif": 380,
	"./Impact_player_screen/home_screen/war_day_bg.gif": 536,
	"./Impact_player_screen/live.png": 214,
	"./Individual_leaderboard.png": 208,
	"./Normal-dist/Arrow_back.png": 376,
	"./Normal-dist/Business_pe_pakad.gif": 625,
	"./Normal-dist/Rectangle_bg.svg": 436,
	"./Normal-dist/Rectangle_bg_1.png": 479,
	"./Normal-dist/Rectangle_blue_1.svg": 437,
	"./Normal-dist/Rectangle_blue_2.png": 480,
	"./Normal-dist/Rectangle_yellow_1.svg": 438,
	"./Normal-dist/Rectangle_yellow_2.png": 481,
	"./Normal-dist/retailer_astra_btn.png": 482,
	"./Normal-dist/retailer_astra_btn_1.png": 483,
	"./Normal-dist/saleastra_bg.png": 484,
	"./Normal-dist/saleastra_btn.png": 485,
	"./Normal-dist/service_astra.png": 486,
	"./Normal-dist/service_astra_btn.png": 487,
	"./Payment_Gateway.png": 328,
	"./Point-logo.png": 67,
	"./Points-box.png": 120,
	"./RefreshSVG.svg": 439,
	"./See-all.png": 488,
	"./Stone-3-with--BG-min.gif": 626,
	"./Utility.png": 197,
	"./ViewDetails.svg": 440,
	"./WarLeaderboard.png": 489,
	"./Wars-won-icon.png": 323,
	"./aeps.png": 198,
	"./all_rounder.png": 490,
	"./animation/1.gif": 627,
	"./animation/10.gif": 628,
	"./animation/11.gif": 629,
	"./animation/12.gif": 630,
	"./animation/13.gif": 631,
	"./animation/14.gif": 632,
	"./animation/15.gif": 633,
	"./animation/16.gif": 634,
	"./animation/17.gif": 635,
	"./animation/18.gif": 636,
	"./animation/19.gif": 637,
	"./animation/2.gif": 638,
	"./animation/20.gif": 639,
	"./animation/21.gif": 640,
	"./animation/22.gif": 641,
	"./animation/3.gif": 642,
	"./animation/4.gif": 643,
	"./animation/5.gif": 644,
	"./animation/6.gif": 645,
	"./animation/7.gif": 646,
	"./animation/8.gif": 647,
	"./animation/9.gif": 648,
	"./arrow-right.svg": 129,
	"./asc.svg": 335,
	"./atm.png": 199,
	"./awtar-image.png": 260,
	"./back-blue.png": 151,
	"./back.png": 50,
	"./background/000_background.gif": 649,
	"./background/001_background.gif": 650,
	"./background/010_background.gif": 651,
	"./background/011_background.gif": 652,
	"./background/100_background.gif": 653,
	"./background/101_background.gif": 654,
	"./background/110_background.gif": 655,
	"./background/111_background.gif": 656,
	"./battle-has-begun.svg": 441,
	"./battle-leaderboard.svg": 337,
	"./battle-over.svg": 442,
	"./bg.png": 491,
	"./bill_payment.png": 492,
	"./bkb-header.png": 339,
	"./bkb-leaderboard-header.png": 493,
	"./bkb3-gifts.png": 257,
	"./black-back.svg": 443,
	"./bonus.svg": 334,
	"./bonus_icon.svg": 444,
	"./bor-img.svg": 338,
	"./cannonsmallbottomnew.png": 121,
	"./canon-catapult-Front-view.gif": 273,
	"./canonbigbottom.png": 122,
	"./canonsmallbottom.png": 494,
	"./card-bg-img-2.svg": 445,
	"./card-bg-img.svg": 446,
	"./cash_rotation_bonus.png": 495,
	"./cashdrop.png": 496,
	"./chat_black.png": 497,
	"./clock.png": 498,
	"./close.png": 62,
	"./congo-profile.png": 304,
	"./congratulation.png": 303,
	"./crown.png": 298,
	"./daily_invest.png": 499,
	"./datebox.png": 343,
	"./defaultProfile.png": 56,
	"./desc.svg": 153,
	"./dhanak.png": 196,
	"./dhanakHub.png": 331,
	"./dhanakRefurb.png": 330,
	"./dmt.png": 200,
	"./down-thumb.png": 302,
	"./down.png": 84,
	"./downLoadMore.png": 500,
	"./dpos.png": 501,
	"./dth.png": 325,
	"./faq-icon.png": 116,
	"./faq.png": 77,
	"./faq1.png": 307,
	"./flight.png": 326,
	"./flights.png": 313,
	"./gatway.png": 502,
	"./gatway_portal.png": 503,
	"./group-chat-arrow.png": 187,
	"./icons-transaction-pending/aeps.png": 352,
	"./icons-transaction-pending/bill_payment.png": 353,
	"./icons-transaction-pending/cashdrop.png": 354,
	"./icons-transaction-pending/daily_invest.png": 355,
	"./icons-transaction-pending/dhanak.png": 356,
	"./icons-transaction-pending/dmt.png": 357,
	"./icons-transaction-pending/dpos.png": 358,
	"./icons-transaction-pending/flights.png": 359,
	"./icons-transaction-pending/gatway.png": 360,
	"./icons-transaction-pending/irctc.png": 361,
	"./icons-transaction-pending/micro_atm.png": 362,
	"./icons-transaction-pending/mpos.png": 363,
	"./icons-transaction-pending/pan_card.png": 364,
	"./icons-transaction-pending/ppi.png": 365,
	"./icons-transaction-pending/recharge.png": 366,
	"./icons-transaction-pending/trans_pending.png": 163,
	"./icons-transaction-pending/utility.png": 367,
	"./impact.png": 204,
	"./impact_bonus.png": 504,
	"./inReview.png": 149,
	"./insurance.png": 505,
	"./irctc.png": 332,
	"./jarvis/jpeg/user.jpeg": 657,
	"./jarvis/png/chatbot.png": 118,
	"./jarvis/png/graph_placeholder.png": 261,
	"./jarvis/png/graph_placeholder_1.png": 262,
	"./jarvis/png/jarvis_bg.png": 136,
	"./jarvis/png/table_placeholder.png": 263,
	"./jarvis/png/user.png": 171,
	"./jarvis/svg/cancel_close.svg": 259,
	"./kingdom.png": 506,
	"./leaderboard.png": 507,
	"./left-arrow-black.png": 152,
	"./level-icon.png": 508,
	"./live.png": 342,
	"./live.svg": 148,
	"./loading.gif": 658,
	"./lock.png": 509,
	"./lose-profile.png": 306,
	"./lose.png": 305,
	"./loser.png": 510,
	"./lost-icon.png": 301,
	"./membership.png": 511,
	"./micro_atm.png": 512,
	"./middle-icon.png": 513,
	"./mpos.png": 514,
	"./other.png": 128,
	"./pan_card.png": 333,
	"./pay-point-icon.svg": 117,
	"./pay1-points-fixed-icon.svg": 447,
	"./pay1-points-img.svg": 68,
	"./points-animationgif.gif": 659,
	"./ppi.png": 515,
	"./rank-act.svg": 448,
	"./rank-inact.svg": 449,
	"./recharge.png": 201,
	"./refresh-white.svg": 336,
	"./refresh.png": 297,
	"./right-arrow.png": 186,
	"./right-white.png": 202,
	"./right.png": 516,
	"./rm-chat-icon.svg": 450,
	"./rm-history.svg": 451,
	"./rm-you-lose.svg": 320,
	"./rm-you-won.svg": 321,
	"./saarthi_bonus.png": 517,
	"./saarthi_bonus_points.png": 518,
	"./score-board-gif.gif": 174,
	"./search.png": 324,
	"./send.png": 294,
	"./share-kd-right.png": 203,
	"./share.png": 322,
	"./slider-bkb.png": 315,
	"./slider-kingdom.png": 316,
	"./slider-war.png": 317,
	"./sort-icon.png": 519,
	"./standings.png": 520,
	"./stat-arrow-red.png": 126,
	"./stat-arrow.png": 127,
	"./stats.png": 521,
	"./sword.gif": 660,
	"./thumb.png": 300,
	"./tips_and_updates.png": 522,
	"./topup.png": 523,
	"./topup.svg": 452,
	"./up.png": 40,
	"./upLoadMore.png": 524,
	"./utility (2).png": 525,
	"./utility.png": 526,
	"./utility_portal.png": 527,
	"./war-began.png": 528,
	"./war.png": 529,
	"./war_points.png": 314,
	"./warzone-icon.png": 308,
	"./wealth-Icon.png": 530,
	"./winner.png": 531,
	"./won-icon.png": 299,
	"./ws-gc-icon.svg": 453,
	"./ws-vd-icon.svg": 454,
	"./you-lose-home.png": 184,
	"./you-lose-war-page.png": 532,
	"./you-won-home.png": 183,
	"./you-won-war-page.png": 533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 164;